module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-800.8378f974.woff2";